export default {
  entityName: "Region",
  apiEndpoint: "/master/regions",
  permissions: {
    view: "master:view",
    edit: "master:edit",
  },
  columns: [
    { key: "name", label: "Region Name", sortable: true },
    { key: "code", label: "Region Code", sortable: true, class: () => "font-mono font-bold" },
  ],
  fields: [
    { name: "name", label: "Region Name", type: "text", required: true, placeholder: "e.g. Asia Pacific" },
    { name: "code", label: "Region Code", type: "text", required: true, uppercase: true, placeholder: "e.g. APAC" },
  ],
  filters: [],
  workflow: {
    type: "region_approval",
    enabled: true,
  },
};
